import {
  IsString, IsNotEmpty,
} from 'class-validator';

export class SignInRequestDTO {
  @IsString()
  @IsNotEmpty()
  public username!: string;

  @IsString()
  @IsNotEmpty()
  // @Matches(/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
  // { message: 'min 8 characters, min 1 upper/lower/number/spec-char' })
  // @Match('username', {
  //   message: 'Can\'t contain username or email',
  // })
  public password!: string;
}
export interface ISignInResponse {
  user_id: number;
  tenant: string;
  accessToken: string;
  accessTokenExpiry: number;
  refreshToken: string;
}
export interface IPermissionResponse {
  user_id: number;
  tenant: string;
  accessToken: string;
  accessTokenExpiry: number;
  refreshToken: string;
}
